import React from "react";
import { connect } from "react-redux";
import { Table, Button } from "react-bootstrap";

function InsuranceList(props) {
  function renderEditButton(insurance) {
    return (
      <div>
        <a
          className="mr-2"
          href="#"
          onClick={(e) => {
            e.preventDefault();
            props.editInsurance(insurance);
          }}
        >
          Edit
        </a>
      </div>
    );
  }

  const { action, newInsurance, editInsurance } = props;
  const insurances = props.insurances.filter((occ) => !occ._destroy);

  return (
    <Table size="sm" responsive>
      <thead>
        <tr>
          <th>Name</th>
          <th>Policy Number</th>
          <th>Group</th>
          <th>Plan</th>
          <th>Other</th>
          <th>Phone</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {insurances.map((insurance) => {
          const { name, policy_number, group, plan, phone_number, other } =
            insurance;

          return (
            <tr key={insurance.id}>
              <td>{name}</td>
              <td>{policy_number}</td>
              <td>{group}</td>
              <td>{plan}</td>
              <td>{other}</td>
              <td>{phone_number}</td>

              <td>{props.action === "edit" && renderEditButton(insurance)}</td>
            </tr>
          );
        })}
        {props.action === "edit" && (
          <tr>
            <td colSpan={7} className="text-center">
              <Button
                variant="link"
                onClick={() => {
                  props.newInsurance();
                }}
              >
                Add Insurance History
              </Button>
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    insurances: state.insurances,
    organization: state.organization,
    resident: state.resident,
    groups: state.groups,
    action: state.ui.action,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editInsurance: (insurance) =>
      dispatch({ type: "EDIT_INSURANCE", payload: insurance }),
    newInsurance: () => dispatch({ type: "NEW_INSURANCE" }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(InsuranceList);
